import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-adjust.tsx
/**
* icon.24.adjust
*
* edit, knobs, settings, configure, config, admin
*
* Keywords: sliders, vertical, controls, settings, adjustment, equalizer, faders
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTguNSAxOGEuNS41IDAgMCAwIC41LS41di0xLjU1YTIuNSAyLjUgMCAwIDAgMC00LjlWNi41YS41LjUgMCAwIDAtMSAwdjQuNTVhMi41MDEgMi41MDEgMCAwIDAgMCA0Ljl2MS41NWEuNS41IDAgMCAwIC41LjVtNyAwYS41LjUgMCAwIDAgLjUtLjV2LTQuNTVhMi41MDEgMi41MDEgMCAwIDAgMC00LjlWNi41YS41LjUgMCAwIDAtMSAwdjEuNTVhMi41IDIuNSAwIDAgMCAwIDQuOXY0LjU1YS41LjUgMCAwIDAgLjUuNW0wLTZhMS41IDEuNSAwIDEgMSAwLTMgMS41IDEuNSAwIDAgMSAwIDNtLTcgM2ExLjUgMS41IDAgMSAxIDAtMyAxLjUgMS41IDAgMCAxIDAgMyIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1571
*/
const Icon24Adjust = memo(function Icon24Adjust(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M8.5 18a.5.5 0 0 0 .5-.5v-1.55a2.5 2.5 0 0 0 0-4.9V6.5a.5.5 0 0 0-1 0v4.55a2.501 2.501 0 0 0 0 4.9v1.55a.5.5 0 0 0 .5.5m7 0a.5.5 0 0 0 .5-.5v-4.55a2.501 2.501 0 0 0 0-4.9V6.5a.5.5 0 0 0-1 0v1.55a2.5 2.5 0 0 0 0 4.9v4.55a.5.5 0 0 0 .5.5m0-6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-7 3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
		})
	});
});
//#endregion
export { Icon24Adjust };

//# sourceMappingURL=icon-24-adjust.js.map